import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  resetPayments: [],

  // All payments
  loadPayments: ['partner', 'params'],
  loadPaymentsSuccess: ['data'],
  loadMorePayments: ['partner', 'params'],
  loadMorePaymentsSuccess: ['data'],
  exportPayments: ['partner', 'params'],
  exportPaymentsSuccess: [],

  // View payment
  loadPayment: ['partner', 'params'],
  loadPaymentSuccess: ['data'],
  loadPaymentTransactionsSuccess: ['data'],
  loadPaymentConsolidatedSuccess: ['data'],
  loadMorePaymentTransactions: ['partner', 'params'],
  loadMorePaymentTransactionsSuccess: ['data'],
  exportPayment: ['partner', 'params'],
  exportPaymentSuccess: []
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  payment: {
    current: {
      loading: true,
      compensate_at: '',
      amount: 0,
      amount_partner: 0,
      amount_recipient: 0
    },
    transactions: {
      loading: true,
      loadingMore: false,
      exporting: false,
      data: {}
    },
    consolidated: {
      loading: true,
      anticipated: 0,
      anticipation: 0,
      total: []
    }
  },
  all: {
    loading: true,
    loadingMore: false,
    exporting: false,
    data: {}
  }
});

const resetPayments = () => INITIAL_STATE;

// ----------------------------------
// All payment ----------------------
// ----------------------------------

const loadPayments = (state, action) => ({
  ...state,
  all: INITIAL_STATE.all
});

const loadPaymentsSuccess = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    loading: false,
    data: action.data
  }
});

const loadMorePayments = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    loadingMore: true
  }
});

const loadMorePaymentsSuccess = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    loadingMore: false,
    data: {
      ...state.all.data,
      total: action.data.total,
      remaining: action.data.remaining,
      entries: [...state.all.data.entries, ...action.data.entries]
    }
  }
});

const exportPayments = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    exporting: true
  }
});

const exportPaymentsSuccess = (state, action) => ({
  ...state,
  all: {
    ...state.all,
    exporting: false
  }
});

// ----------------------------------
// View payment ---------------------
// ----------------------------------

const loadPayment = (state, action) => ({
  ...state,
  payment: INITIAL_STATE.payment
});

const loadPaymentSuccess = (state, action) => ({
  ...state,
  payment: {
    ...state.payment,
    current: {
      ...state.payment.data,
      ...action.data,
      loading: false
    }
  }
});

const loadPaymentTransactionsSuccess = (state, action) => ({
  ...state,
  payment: {
    ...state.payment,
    transactions: {
      ...state.payment.transactions,
      loading: false,
      data: action.data
    }
  }
});

const loadPaymentConsolidatedSuccess = (state, action) => ({
  ...state,
  payment: {
    ...state.payment,
    consolidated: {
      ...state.payment.consolidated,
      ...action.data,
      loading: false
    }
  }
});

const loadMorePaymentTransactions = (state, action) => ({
  ...state,
  payment: {
    ...state.payment,
    transactions: {
      ...state.payment.transactions,
      loadingMore: true
    }
  }
});

const loadMorePaymentTransactionsSuccess = (state, action) => ({
  ...state,
  payment: {
    ...state.payment,
    transactions: {
      ...state.payment.transactions,
      loadingMore: false,
      data: {
        ...state.payment.data,
        total: action.data.total,
        remaining: action.data.remaining,
        entries: [
          ...state.payment.transactions.data.entries,
          ...action.data.entries
        ]
      }
    }
  }
});

const exportPayment = (state, action) => ({
  ...state,
  payment: {
    ...state.payment,
    transactions: {
      ...state.payment.transactions,
      exporting: true
    }
  }
});

const exportPaymentSuccess = (state, action) => ({
  ...state,
  payment: {
    ...state.payment,
    transactions: {
      ...state.payment.transactions,
      exporting: false
    }
  }
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.RESET_PAYMENTS]: resetPayments,

  // All payments
  [Types.LOAD_PAYMENTS]: loadPayments,
  [Types.LOAD_PAYMENTS_SUCCESS]: loadPaymentsSuccess,
  [Types.LOAD_MORE_PAYMENTS]: loadMorePayments,
  [Types.LOAD_MORE_PAYMENTS_SUCCESS]: loadMorePaymentsSuccess,
  [Types.EXPORT_PAYMENTS]: exportPayments,
  [Types.EXPORT_PAYMENTS_SUCCESS]: exportPaymentsSuccess,

  // View payment
  [Types.LOAD_PAYMENT]: loadPayment,
  [Types.LOAD_PAYMENT_SUCCESS]: loadPaymentSuccess,
  [Types.LOAD_PAYMENT_TRANSACTIONS_SUCCESS]: loadPaymentTransactionsSuccess,
  [Types.LOAD_PAYMENT_CONSOLIDATED_SUCCESS]: loadPaymentConsolidatedSuccess,
  [Types.LOAD_MORE_PAYMENT_TRANSACTIONS]: loadMorePaymentTransactions,
  [Types.LOAD_MORE_PAYMENT_TRANSACTIONS_SUCCESS]: loadMorePaymentTransactionsSuccess,
  [Types.EXPORT_PAYMENT]: exportPayment,
  [Types.EXPORT_PAYMENT_SUCCESS]: exportPaymentSuccess
});
